import { render, staticRenderFns } from "./UserProfileCertificatesList.vue?vue&type=template&id=a6486570&scoped=true"
import script from "./UserProfileCertificatesList.vue?vue&type=script&lang=js"
export * from "./UserProfileCertificatesList.vue?vue&type=script&lang=js"
import style0 from "./UserProfileCertificatesList.vue?vue&type=style&index=0&id=a6486570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6486570",
  null
  
)

export default component.exports